import type { LegacyAdnetApi } from '@/composables/api/useLegacyCreativeApi';

export type LegacyPageRequest = Readonly<{ params?: Record<string, unknown>; signal?: AbortSignal }>;

// Bypasses Vuex on purpose: advert/fetch* commit into fields others read as full directories, so a partial page there hides entries.
// TODO: move those directories to TanStack queries, then drop this helper.
export const fetchLegacyPage = (
  api: Pick<LegacyAdnetApi, 'get'>,
  endpoint: string,
  request: LegacyPageRequest = {},
): Promise<unknown> => {
  const { params, signal } = request;
  if (!params && !signal) {
    return api.get(endpoint);
  }
  return api.get(endpoint, { ...(params ? { params } : {}), ...(signal ? { signal } : {}) });
};
